import React from 'react';
import Comment from 'components/Comment/Comment.js';
import Dropzone from 'react-dropzone';
import Modal from 'components/Modal/Modal.js';
import { Link } from 'react-router-dom';
import { config } from 'Constants.js';
import Share from 'components/Share/Share.js';
import Sdropdown from 'components/Sdropdown/Sdropdown.js';
import Commentsidebar from 'components/Commentsidebar/Commentsidebar.js';
import $ from 'jquery';
import queryString from 'query-string'
import Notifications from 'components/Notifications/Notifications.js';
import { HotKeys } from 'react-keyboard';
import Hotkeys from 'react-hot-keys';
import { FaPen,FaArrowRight,FaArrowLeft,FaAngleDown, FaWindowClose } from 'react-icons/fa';
import Commenter from 'components/Commenter/Commenter.js';
import Moment from 'react-moment';
import axios from 'axios';

export default class Screen extends React.Component {
	constructor(props) {
    	super(props);
    	this.state = {ballonOpen:false, image_id:props.match.params.id, name: '', description:'', version:1, path: '', parent:0, project_id:0,project_name:'',comments:[],versions:[],isHidden:true, top:0, left:0, x_pos:0, y_pos:0, showModal:false, showMenu:false, prominent:false, version_id:'', showShare: false, editTitle: false, canEdit:false, shrink:false, showCommentsidebar: false, nlist:[], canUpload:false, commentId:'', activePolilynes:[], approved:false,updated:new Date(),scrTo:false,loginModal:false,email:"",password:"",error:"",zoomLevel:1,user_name:'',isOpen:false,files:{},cfiles:[],uploadProgress:{},showConfirm:false,delIndex:null,showDiscard:false,ccid:0};
    	this.image = {};
    	this.prev = {};
    	this.next = {};
    	this.user_id = {};
    	this.handleClick = this.handleClick.bind(this);
    	this.appendComment = this.appendComment.bind(this);
    	this.handleDragEnter = this.handleDragEnter.bind(this);
    	this.handleDragLeave = this.handleDragLeave.bind(this);
    	this.toggleMenu = this.toggleMenu.bind(this);
    	this.loadImage = this.loadImage.bind(this);
    	this.reloadImage = this.reloadImage.bind(this);
    	this.loadVersion = this.loadVersion.bind(this);
    	this.authUser = window.localStorage.getItem('auth_user')==null?{id:null,name:null}:JSON.parse(window.localStorage.getItem('auth_user'));
    	this.showNotifypopup = this.showNotifypopup.bind(this);
    	this.showSharepopup = this.showSharepopup.bind(this);
    	this.editToggle = this.editToggle.bind(this);
    	this.handleImgTitleChange = this.handleImgTitleChange.bind(this);
    	this.handleImgTitleEdit = this.handleImgTitleEdit.bind(this);
    	this.handleImgDescChange = this.handleImgDescChange.bind(this);
    	this.approveScreen = this.approveScreen.bind(this);
    	this.updateScreen = this.updateScreen.bind(this);
    	this.deleteScreen = this.deleteScreen.bind(this);
    	this.deleteVersion = this.deleteVersion.bind(this);
    	this.shrinkScreen = this.shrinkScreen.bind(this);
    	this.showComments = this.showComments.bind(this);
    	this.copyComments = this.copyComments.bind(this);
    	this.onEnterPress = this.onEnterPress.bind(this);
    	this.hideComments = this.hideComments.bind(this);
    	this.toggleComments = this.toggleComments.bind(this);
    	this.loadComments = this.loadComments.bind(this);
    	this.sortComments = this.sortComments.bind(this);
    	this.toggleShare = this.toggleShare.bind(this);
    	this.currentComment = '';
	    this.handleInputChange = this.handleInputChange.bind(this);
	    this.seenAll = this.seenAll.bind(this);
	    this.openComment = this.openComment.bind(this);
	    this.zoomIn = this.zoomIn.bind(this);
	    this.zoomOut = this.zoomOut.bind(this);
	    this.setIsOpen = this.setIsOpen.bind(this);
	    this.handleUpload = this.handleUpload.bind(this);
	    this.updateNotification = this.updateNotification.bind(this);
			this.handleFileChange = this.handleFileChange.bind(this);
			this.cancelUpload = this.cancelUpload.bind(this);
			this.deleteFile = this.deleteFile.bind(this);
			this.removeFiles = this.removeFiles.bind(this);
			this.closeConfirm = this.closeConfirm.bind(this);
			this.closeDiscard = this.closeDiscard.bind(this);
			this.confirmDiscard = this.confirmDiscard.bind(this);
			this.setCcid = this.setCcid.bind(this);
    }
    setCcid(i){
    	this.setState({'ccid':i});
    }
    confirmDiscard(){
    	this.setState({'isHidden':true,'showDiscard':false});
    	let cfiles = this.state.cfiles;
    	cfiles=[];
			this.setState({'cfiles':cfiles});
    }
    closeDiscard(){
    	this.setState({'showDiscard':false});
    }
    deleteFile(i){
    	this.setState({'delIndex':i});
    	this.setState({showConfirm:true});
  		this.setIsOpen(false);
    }
  	handleUpload(){
  		let files = this.state.files;
  		let cfiles = this.state.cfiles;
  		let uploadProgress = this.state.uploadProgress;
  		if(!files[this.state.ccid]) files[this.state.ccid]=[];
  		cfiles.forEach((file)=>{console.log(file); console.log(uploadProgress)
  			files[this.state.ccid] = [...files[this.state.ccid],uploadProgress[file.name]['path']];
  		});
    	this.setState({files:files,cfiles:[]});
	    this.setIsOpen(false);
  	}
  	removeFiles(){
  		if(this.state.delIndex!=null){
  			let cfiles = this.state.cfiles;
	    	cfiles.splice(this.state.delIndex,1);
				this.setState({'cfiles':cfiles});
				this.setState({showConfirm:false});
	  		this.setIsOpen(true);
  		}
  		else{
	  		this.setState({showConfirm:false});
	  		this.setIsOpen(false);
	      let files = this.state.files;
	    	files[this.state.ccid]=[];
				this.setState({'files':files});
				this.setState({'cfiles':[]});
	      this.setState({'uploadProgress':{}});
      }
      this.setState({'delIndex':null});
  	}
  	closeConfirm(){
  		this.setState({showConfirm:false,showDiscard:false});
  		this.setIsOpen(true);
  		this.setState({'delIndex':null});
  	}
  	cancelUpload(){
  		this.setState({showConfirm:false});
  		this.setIsOpen(false);
  	}
    setIsOpen(st,k=null){
    	this.setState({isOpen:st});
    	if(k!==null)
    	this.setCcid(k);
    }
    handleFileChange = async(e) => {
    	let allfiles = Array.from(e.target.files);
    	let cfiles = this.state.cfiles;
    	cfiles = [...cfiles,...allfiles];
    	this.setState({cfiles:cfiles});
    	allfiles.forEach(async(file,i) => {
	      const formData = new FormData();
	      formData.append('file', file);
	      let uploadProgress = this.state.uploadProgress;
	      uploadProgress[file.name] = {percent:0,completed:false,error:false};
	      await axios.post(config.url.API_URL+'upload', formData, {
	        onUploadProgress: (progressEvent) => {
	          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
	          uploadProgress[file.name]['percent'] = percent;
	          this.setState({uploadProgress: uploadProgress });
	        },
	      })
	      .then((responses) => {
			    uploadProgress[file.name]['completed'] = true;
			    uploadProgress[file.name]['path'] = responses.data.image;
          this.setState({uploadProgress: uploadProgress });
			  })
			  .catch((error) => {
			    uploadProgress[file.name]['error'] = true;
          this.setState({uploadProgress: uploadProgress });
			  });
	    });
	  }
    zoomOut(){
    	if(this.state.zoomLevel<1){
	    	var myImg = document.getElementById("mainImage");
				var currWidth = myImg.naturalWidth;
				let zoomLevel = this.state.zoomLevel + 0.1;
				myImg.style.width = (currWidth * zoomLevel).toFixed(0) + "px";
				this.setState({zoomLevel:zoomLevel});
			}
    }
    zoomIn(){
    	if(this.state.zoomLevel>0.2){
	    	var myImg = document.getElementById("mainImage");
				var currWidth = myImg.naturalWidth;
				let zoomLevel = this.state.zoomLevel - 0.1;
				myImg.style.width = (currWidth * zoomLevel).toFixed(0) + "px";
				this.setState({zoomLevel:zoomLevel});
			}
    }
    toggleShare(){
    	if(this.state.showShare) this.setState({showShare:false});
    }
    handleInputChange = (event) => {
	    const { value, name } = event.target;
	    this.setState({
	      [name]: value
	    });
  	}
    onSubmit = (event) => {
	    event.preventDefault();
	    fetch(config.url.API_URL+'authenticate', {
	      method: 'POST',
	      body: JSON.stringify(this.state),
	      headers: {
	        'Content-Type': 'application/json'
	      }
	    })
	    .then(res => {
	      if (res.status === 200) {
	        res.json().then(json => {
	          window.localStorage.setItem('auth_user',JSON.stringify({id:json._id,name:json.name,email:json.email,expiry_date:json.expiry_date,stripe_subscription_id:json.stripe_subscription_id,stripe_plan_id:json.stripe_plan_id,color:json.color}));
	          setTimeout(()=>{
	            window.location.reload();
	          },200);
	        });
	        //this.props.history.push('/');
	      } else {
	        const error = new Error(res.error);
	        throw error;
	      }
	    })
	    .catch(err => {
	      this.setState({
	        'error': 'Invalid details!/Not yet activated'
	      });
	      // toast.error('Invalid details!/Not yet activated');
	    });
  	}
  	onSubmitGuest = (event) => {
	    event.preventDefault();
	    if(this.state.user_name.trim()!==''){
	    	window.localStorage.setItem('firsttime',this.state.user_name);
	    	this.setState({loginModal:false});
	    }
  	}
    sortComments(s){
    	// let sortedCommentsDsc;
		// if (s.target.value=='desc') {
		//     sortedCommentsDsc= this.state.comments.sort((a,b)=>{
		// 		  if (a.updated  < b.updated) {
		// 		    return 1;
		// 		  }
		// 		  if (a.updated > b.updated) {
		// 		    return -1;
		// 		  }
		// 		  return 0;
		//     });
		//     this.setState({
		//         comments:sortedCommentsDsc
		//     });
	    // }
	    // else{
	    // 	sortedCommentsDsc= this.state.comments.sort((a,b)=>{
		// 		  if (a.updated  > b.updated) {
		// 		    return 1;
		// 		  }
		// 		  if (a.updated < b.updated) {
		// 		    return -1;
		// 		  }
		// 		  return 0;
		//     });
		//     this.setState({
		//         comments:sortedCommentsDsc
		//     });
	    // }
    }
    toggleComments(){
    	if(!this.state.showCommentsidebar){
    		this.showComments();
    	}
    	else{
    		this.hideComments();
    	}
    }
    hideComments(){
    	// $('#commentSidebar').addClass('transition-leave-active').addClass('transition-leave');
	  	// $('.image').removeClass('showing-comments-sidebar');
    	// setTimeout(()=>{
			this.setState({showCommentsidebar:false,commentId:'', activePolilynes:[]});
		// },1000);
    }
    async loadNotify(){
			const notif = await fetch(config.url.API_URL+'notifications',{ method: "POST", body: JSON.stringify({image_id:this.state.image_id, user_id: this.authUser.id, version_id:this.state.version_id}), headers: { 'Content-Type': 'application/json' }});
	    const notifications = await notif.json();
	    this.setState({nlist:notifications});
    }
    updateNotification(i){
    	let notifications2 = this.state.nlist;
    	notifications2[i].read = true;
    	this.setState({nlist:notifications2});
    }
    seenAll(){
    	fetch(config.url.API_URL+'seenall',{ method: "POST", body: JSON.stringify({image_id:this.state.image_id, user_id: this.authUser.id}), headers: { 'Content-Type': 'application/json' }});
    	this.setState({nlist:[]});
    }
    componentDidMount() {
    	const values = queryString.parse(this.props.location.search);
    	if(values.showing_comment!==undefined){
    		this.currentComment = values.showing_comment;
    	}
    	this.loadImage();
    	window.addEventListener('click', (e)=>{   
    		if (document.getElementById('comment_box0')!=null) {
				  if (document.getElementById('comment_box0').contains(e.target)){
				    //nothing
				  } else if (document.getElementById('mainImage').contains(e.target)){
				    //nothing
				  }
				  else{
				  	if(!this.state.isOpen && this.state.cfiles?.length>0){
				  		if($(e.target).closest('.modal').length==0){
				  			this.setState({'showDiscard':true});
				  		}
				  	}
				  	else{
				  		if($(e.target).closest('.modal').length==0){
				  			// this.setState({isHidden:true});
				  		}
				  	}
				  }
		  	}
		  	if (document.getElementById('versionButton')!=null) {
			  if (document.getElementById('versionButton').contains(e.target)){
			    //nothing
			  }
			  else{
			  	this.setState({showMenu:false});
			  }
		  	}
		});
		document.body.classList = 'singlepage';
		document.getElementById('mainImage').addEventListener('load', ()=>{
			this.shrinkScreen();
			//checkcomment
			let hash = window.location.hash;
			if(hash!=''){
				setTimeout(()=>{
					this.openComment();
				},2000);
			}
			//checklogin
			if(!this.authUser.id && window.localStorage.getItem('firsttime')==null){
  			this.setState({loginModal:true});
  		}
		});
		window.addEventListener("hashchange", this.openComment, false);
  } 
  componentWillUnmount() {
    document.body.classList = '';
    window.removeEventListener("hashchange", this.openComment, false);
  }
  openComment(){
  	let hash = window.location.hash;
  	if($('#comment_box'+hash.replace('#','')).length>0){
  		$('.comment-group').removeClass('open');
			$('#comment_box'+hash.replace('#','')).addClass('open');
			window.scrollTo($('#comment_box'+hash.replace('#','')).offset().left,$('#comment_box'+hash.replace('#','')).offset().top - 200);
		}
  }
  handleClick = (event) =>{
  	if(!this.state.isOpen && this.state.cfiles?.length>0){
  		if(this.state.ccid==0){
  			this.setState({'showDiscard':true});
  		}
  	}
  	else{
	  	var bounds = event.target.getBoundingClientRect();
	  	var x = event.clientX - bounds.left;
			var y = event.clientY - bounds.top;

			var w = event.target.clientWidth;
			var h = event.target.clientHeight;
			
			var xper = (x/w)*100;
			var yper = (y/h)*100;

			//console.log(xper + ' - ' + yper);
			if($(event.target).closest('.modal').length==0){
	  		this.setState({isHidden: !this.state.isHidden, top: yper, left: xper, x_pos: x, y_pos: y});
	  	}
  	}
  }
  handleDragEnter = (event) => {
		this.setState({ showModal: true });
	}
	handleDragLeave = (event) => {
		this.setState({ showModal: false });
	}
	toggleMenu = (event) => {
		this.setState({ showMenu: !this.state.showMenu });
	}
	reloadImage(){
		setTimeout(()=>{
			this.loadImage();
		},200);
	}
	handlersParent = {
	    left: ()=>{
	    	if(this.prev){
	    		this.props.history.push('/'+this.prev._id);
	    		this.reloadImage();
	    	}
	    },
	    right: ()=>{
	    	if(this.next){
	    		this.props.history.push('/'+this.next._id);
	    		this.reloadImage();
	    	}
	    }
	}
	async loadImage(){
		//Comment
		// window.localStorage.removeItem('image_'+this.props.match.params.id);
		// if(window.localStorage.getItem('image_'+this.props.match.params.id)==null){
		    const response = await fetch(config.url.API_URL+'screen',{
			  	method: "POST",
		  		body: JSON.stringify({id:this.props.match.params.id, user_id:this.authUser.id}),
			    headers: {
			        'Content-Type': 'application/json'
			    }
			});
		    let result = await response.json();
		    this.image = result.image;
		    this.prev = result.prev!==undefined?result.prev:null;
		    this.next = result.next!==undefined?result.next:null;
		    this.user_id = result.user;
		    //window.localStorage.setItem('image_'+this.props.match.params.id,JSON.stringify(this.image));
		    this.setStateValues(this.image);
		// }
		// else{
		// 	this.image = JSON.parse(window.localStorage.getItem('image_'+this.props.match.params.id));
		// 	//console.log(this.image);
		// 	this.setStateValues(this.image);
		// }
	}
	setStateValues(image){
		this.setState({image_id: image._id, name: image.name, description: image.description, version: image.versions.length, path: config.url.IMAGE_URL+image.image, parent: image._id, project_id: image.project?image.project._id:0, project_name: image.project?image.project.name:'', ballonOpen:false});
	    this.setState({versions:image.versions});
	    if(this.props.match.params.version>0){
	    	this.loadVersion();
	    }
	    this.setState({version_id:image.versions[image.versions.length-1]._id});
	    this.loadComments();
	    this.loadNotify();
	    if(image.project && image.project.shared){
		    image.project.shared.forEach((v,k)=>{
		    	if (this.authUser.id===v.user && v.access===true) {
	    			this.setState({canUpload:true});
	    		}
	    	});
    	}
    	if (this.user_id===this.authUser.id || this.state.canUpload) {
	    	this.setState({canEdit:true});
	    }
	    //console.log(this.state);
	}
	loadComments(){
		if (this.state.version_id!=='') {
		//Comment
		// window.localStorage.removeItem('comments_'+this.state.version_id);
		// if(window.localStorage.getItem('comments_'+this.state.version_id)==null){
			fetch(config.url.API_URL+"comments", {
			  	method: "POST",
		  		body: JSON.stringify({id:this.state.version_id}),
		  		headers: {
			        'Content-Type': 'application/json'
			    }
			}).then(function (response) {
	            return response.json();
		    }).then( (resp) => {
		    	this.setState({comments: resp});  
		    	this.sortComments({target:{value:'desc'}});
		    	//window.localStorage.setItem('comments_'+this.state.version_id,JSON.stringify(resp));
		    	// resp.forEach(val=>{
			    // 	this.setState({comments: [...this.state.comments,val]});  
			    // }); 
		    });
		// }
		// else{
		// 	let resp = JSON.parse(window.localStorage.getItem('comments_'+this.state.version_id));
		// 	resp.forEach(val=>{
		//     	this.setState({comments: [...this.state.comments,val]});  
		//     }) 
		// }
		}
	}
	appendComment(comment){
		this.setState({isHidden: true, ballonOpen: false, comments: [...this.state.comments,comment]});
		//window.localStorage.setItem('comments_'+this.state.version_id,JSON.stringify(this.state.comments));
	}

	handleDrop = (acceptedFiles) => {
		let file = acceptedFiles[0];
		const  fileType = file['type'];
		const  fileSize = file['size'];
		const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
		if(fileSize > 10485760){
            alert("Reduce it, so it's less than 10MB");
            return;
        }
		if (!validImageTypes.includes(fileType)) {
			alert('Only accept images at this moment. Try uploading a PNG!\nThere\'s good reason we keep website simple and purposeful to maximise efficient, fast feedback from your coleagues.');
		    return;
		}

		this.setState({ showModal: false, comments: [], versions: [] });
		const formData = new FormData();
		formData.append('project_id', this.state.project_id);
    	formData.append('user_id', this.authUser.id);
    	formData.append('file', file);
    	formData.append('parent', this.state.image_id);
    	fetch(config.url.API_URL+"uploadscreen", {
		  	method: "POST",
	  		body: formData
		}).then(function (response) {
            return response.json();
	    }).then( (resp) => {
	    	this.image = resp;
	    	this.props.history.push('/'+this.state.image_id+'/'+resp.versions.length);
	    	setTimeout(()=>{
		    	this.setStateValues(resp);
		    });
	    });
	}
	loadVersion(){
		this.setState({ showModal: false, comments: [], showMenu:false, prominent:true });
		setTimeout(()=>{
			//this.loadImage(); , name: v.name
			let v = this.image.versions[this.props.match.params.version-1];
			this.setState({image_id: this.image._id, description: v.description, version: parseInt(this.props.match.params.version), path: config.url.IMAGE_URL+v.image, ballonOpen:false, version_id: v._id, approved: v.approved, updated:v.created});
			this.loadComments();
			this.loadNotify();
		},500);
		setTimeout(()=>{
	    	this.setState({prominent:false});
	    },10000);
	}
	showNotifypopup() {
    }
    showSharepopup(){
    	this.setState({showShare: true});   
    }
    closeModal = (event) => {
		this.setState({ showModal: false, showShare: false, loginModal:false });
	}
	updateScreen(){
		document.getElementById('fileInput').click();
	}
	deleteScreen(){
		fetch(config.url.API_URL+"deletedesign", {
          method: "POST",
          body: JSON.stringify({id:this.state.image_id}),
          headers: {
            'Content-Type': 'application/json'
        }
    }).then(function (response) {
        return response.json();
    }).then((result)=>{
        window.location.replace('/p/'+this.state.project_id);
    });
	}
	deleteVersion(ind){
		const imgpath = this.image.versions.length === (ind+1)?this.image.versions[(ind-1)].image:'';
		const imgname = this.image.versions.length === (ind+1)?this.image.versions[(ind-1)].name:'';
		fetch(config.url.API_URL+"deleteversion", {
              method: "POST",
              body: JSON.stringify({id:this.state.image_id, version_id: this.image.versions[ind]._id, image: imgpath, name: imgname}),
              headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            return response.json();
        }).then((result)=>{
        	window.location.replace('/'+this.state.image_id);
        });
	}
	shrinkScreen(){
		var myImg = document.getElementById("mainImage");
		var currWidth = myImg.width;
		this.setState({shrink:!this.state.shrink});
		setTimeout(()=>{
			if (this.state.shrink) {
		        myImg.style.width = (currWidth * this.state.zoomLevel).toFixed(0) + "px";
			}
			else{
		        myImg.style.width = null;
			}
		},10);
	}
	showComments(commentId,ck){
		let cc = this.state.comments.filter(a=>a._id==commentId);
		this.setState({showCommentsidebar:true,commentId:commentId, activePolilynes:cc[0].polylines,scrTo:ck});
		if(!ck) window.scrollTo(cc[0].x_pos-100,cc[0].y_pos);
		// $('.image').addClass('showing-comments-sidebar');
		// setTimeout(()=>{
		// 	$('#commentSidebar').removeClass('transition-enter').removeClass('transition-enter-active');
		// },1000);
	}
	copyComments(){
		fetch(config.url.API_URL+"clonecomments", {
		  	method: "POST",
	  		body: JSON.stringify({id:this.props.match.params.id, version_id: this.state.version_id, prev_version_id:this.image.versions[this.image.versions.length-2]._id}),
	  		headers: {
		        'Content-Type': 'application/json'
		    }
		}).then(function (response) {
            return response.json();
	    }).then( (result) => { 
	    	this.loadComments();
	    });
		
	}
	approveScreen = (ind) => {
		fetch(config.url.API_URL+"approvescreen", {
		  	method: "POST",
	  		body: JSON.stringify({id:this.props.match.params.id, approved:!this.image.versions[ind].approved, version: this.props.match.params.version, version_id: this.state.version_id}),
	  		headers: {
		        'Content-Type': 'application/json'
		    }
		}).then(function (response) {
            return response.json();
	    }).then( (result) => { 
	    	console.log(this.state.approved)
	    	this.setState({approved:!this.state.approved})
	    });
	}
	handleImgTitleChange = (event) => {
		this.setState({editTitle:false});
		if(this.state.name!==event.target.value){
			this.setState({name: event.target.value});   
			fetch(config.url.API_URL+"updatescreen", {
			  	method: "POST",
		  		body: JSON.stringify({id:this.props.match.params.id, name:event.target.value, description: this.state.description, version: this.props.match.params.version, version_id: this.state.version_id}),
		  		headers: {
			        'Content-Type': 'application/json'
			    }
			}).then(function (response) {
	            return response.json();
		    }).then( (result) => { 
		    	
		    });
	    }
	}
	handleImgTitleEdit = (name) => {
		this.setState({editTitle:false});
		if(this.state.name!==name){
			this.setState({name: name});   
			fetch(config.url.API_URL+"updatescreen", {
			  	method: "POST",
		  		body: JSON.stringify({id:this.props.match.params.id, name:name, version: this.props.match.params.version, version_id: this.state.version_id}),
		  		headers: {
			        'Content-Type': 'application/json'
			    }
			}).then(function (response) {
	            return response.json();
		    }).then( (result) => { 
		    	
		    });
	    }
	}
	handleImgDescChange = (event) => {
		if(this.state.description!==event.target.value){
		  this.setState({description: event.target.value});   
			fetch(config.url.API_URL+"updatescreen", {
			  	method: "POST",
		  		body: JSON.stringify({id:this.props.match.params.id, description:event.target.value, name: this.state.name, version: this.props.match.params.version, version_id: this.state.version_id}),
		  		headers: {
			        'Content-Type': 'application/json'
			    }
			}).then(function (response) {
	            return response.json();
		    }).then((result)=>{
		    });
		}
	}
	editToggle(){
		if (this.state.canEdit) {
			this.setState({editTitle:!this.state.editTitle});
			setTimeout(()=>{
				if(this.state.editTitle){
					document.getElementById("imageName").focus();
					document.getElementById("imageName").value = document.getElementById("imageName").value;
					var len = document.getElementById("imageName").value.length * 2;
			      	setTimeout(function() {
			        	document.getElementById("imageName").setSelectionRange(len, len);
			      	}, 1);
					this.setState({showMenu:false});
				}
			},50);
		}
	}
	onEnterPress = (e) => {
    	if(e.keyCode === 13 && e.shiftKey === false) {
		    e.preventDefault();
		    this.handleImgTitleChange(e);
		}
    }
	render() {
		const keyMap = {
		  left: 'left',
		  right: 'right'
		}
		let next=null, prev=null, title=null;
		if (this.image.project!==undefined) {
			if(this.prev){
				prev = <button><Link onClick={() => window.location.href='/'+this.prev._id} to={'/'+this.prev._id}><FaArrowLeft/>Previous design </Link></button>
			}
			else{
				prev = <button><FaArrowLeft/><span>Previous design  </span></button>
			}
			if(this.next){
				next = <button><Link onClick={() => window.location.href='/'+this.next._id} to={'/'+this.next._id}>Next design<FaArrowRight/></Link></button>
			}
			else{
				next = <button><span>Next design<FaArrowRight/></span></button>
			}
		}
		if (this.state.editTitle) {
			title = <textarea id="imageName" onKeyDown={this.onEnterPress} defaultValue={this.state.name} className="title not-empty" placeholder="Image name" onBlur={this.handleImgTitleChange}></textarea>
		}
		else{
			title = <h1 className="title">
									<span className="ver_bg2">{this.state.versions.length>0?(<button onClick={this.toggleMenu} id="versionButton" className={'version '+ (this.state.prominent?'prominent':'')}>v{this.state.version}</button>):''}</span> <span >{this.state.name} <div className="dat_time"><Moment format="DD MMM YY hh:mma">{this.state.updated}</Moment></div></span>

										</h1>
		}
		return (
			<Dropzone noClick={true} multiple={false} onDragEnter={this.handleDragEnter} onDragLeave={this.handleDragLeave} onDrop={this.handleDrop} noDrag={this.state.project_id===0 || this.authUser.id!==this.user_id}>
				{({getRootProps, getInputProps}) => (
						<div className="page_body page_body2 view_fullpage">
						<div className="page_wrapper ">
							<div className="container1">

					<div className="screen des_single fullscreen_view" {...getRootProps()}>
						 
						
						<div className="content" style={{"background":"white"}}>
							
							
							<div className="shotheader_sec">

							<header className="shot-header">
								<section className="editable">
								<div className="title-container">
										{title}
										{this.state.showMenu?(
										<menu className="dropdown-menu on-dark version-menu column-reverse">
											<ul>
												{this.state.versions.map((version,key) => (
													<li key={key} className="" onClick={this.loadVersion}>
														<Link to={'/'+this.state.image_id+'/'+(key + 1)}>
																<span>
																	<span>Version </span>
																	<span>{key + 1}</span>
																	<span></span>
																	<span>{(key + 1)===this.state.version?' (this one)':''}</span>
																</span>
														</Link>
													</li>
												))}
											</ul>
										</menu>
										):''}
									</div>
									<Sdropdown name={this.state.name} handleImgTitleEdit={this.handleImgTitleEdit} user={this.user_id} updateScreen={this.updateScreen} deleteScreen={this.deleteScreen} deleteVersion={this.deleteVersion} shrinkScreen={this.shrinkScreen} showComments={this.showComments} copyComments={this.copyComments} version={this.state.version} versions={this.state.versions} shrink={this.state.shrink} project={this.state.project_id} canUpload={this.state.canUpload} approveScreen={this.approveScreen} approved={this.state.approved} seenAll={this.seenAll} nlist={this.state.nlist} comments={this.state.comments}></Sdropdown>
									
									
									{/*<div className="description-container">
										<textarea disabled={!this.state.canEdit} className="description" placeholder="Add a description — the purpose, context, objectives..." style={{resize: 'none', overflowY: 'hidden', height: '32px'}} onBlur={this.handleImgDescChange} defaultValue={this.state.description}>
										</textarea>
									</div>*/}
								</section>
							</header>

							</div>

							<div className="pagenation">
								<button><Link to={'/p/'+this.state.project_id}><FaArrowLeft/>Back </Link></button> {prev} {next} <div className="zoom_btns"><button title="Zoom In" className="zoom_in" onClick={this.zoomIn}>-</button> <button className="zoom_out" title="Zoom Out" onClick={this.zoomOut}>+</button> </div>
							</div>
							
							<div className="image">
								<div className="image-wrapper">
								<img id="mainImage" src={this.state.path} alt={this.state.name} onClick = {this.handleClick} />
								{/*this.state.path!=''?<Commenter image={this.state.path} imageId={this.state.image_id} versionId={this.state.version_id} isHidden = {this.state.isHidden} ballonOpen = {true} top = {this.state.top} left = {this.state.left} replies = {[]} commentId={0} appendComment={this.appendComment} projectId={this.state.project_id} activePolilynes={this.state.activePolilynes} />:null*/}
								{this.state.comments.map((comment,key) => (
									<Comment showComments={this.showComments} key={key} idx={key} imageId={this.state.image_id} versionId={this.state.version_id} isHidden = {false} ballonOpen = {this.currentComment===comment._id?true:this.state.ballonOpen} color={comment.color} top = {comment.y_pos} left = {comment.x_pos} replies = {comment.replies} commentId={comment._id} notification={this.state.nlist} zoomLevel={this.state.zoomLevel} appendComment={this.appendComment} projectId={this.state.project_id} updateNotification={this.updateNotification} files={this.state.files[comment._id]??[]} uploadProgress={this.state.uploadProgress} setIsOpen={this.setIsOpen} setCcid={this.setCcid} removeFiles={this.removeFiles} /> 
								))}
								<Comment idx={this.state.comments.length} imageId={this.state.image_id} versionId={this.state.version_id} isHidden = {this.state.isHidden} ballonOpen = {true} top = {this.state.top} left = {this.state.left} replies = {[]} commentId={0} notification={[]} zoomLevel={this.state.zoomLevel} appendComment={this.appendComment} setCcid={this.setCcid} projectId={this.state.project_id} files={this.state.files[0]??[]} uploadProgress={this.state.uploadProgress} setIsOpen={this.setIsOpen} removeFiles={this.removeFiles} /> 
								</div>
							</div>
							</div>
						</div>
						</div>
						</div>
						<Modal showModal={this.state.loginModal} handleClose={this.closeModal}>
						{/*<input className="close_popup" type="button" onClick={this.closeModal} value="X"/>*/}
						<form onSubmit={this.onSubmit}>

							<h2>Login</h2>
							{this.state.error != ''?<div className="error_block">{this.state.error}</div>:''}
				          	<ul className="login_popup login_box">
			                  <li>
			                    <label>Email Address</label>
			                    <input type="email" name="email" placeholder="Email" value={this.state.email} onChange={this.handleInputChange} required /> 
			                  </li>
			                  <li>
			                    <label>Password</label>
			                    <input type="password" name="password" placeholder="Password" value={this.state.password} onChange={this.handleInputChange} required /> </li>
			                  <li><input type="submit" value="Log In"/> </li>
			                </ul>
			          	</form>
			          	<h4>(OR)</h4>
			          	<form onSubmit={this.onSubmitGuest}>
			          		<ul className="login_popup login_box">
			                  <li>
			                    <label>Name</label>
			                    <input type="text" name="user_name" placeholder="Name" value={this.state.user_name} onChange={this.handleInputChange} required /> 
			                  </li>
			                  <li><input type="submit" value="Submit"/> </li>
			                </ul>
			          	</form>
			        </Modal>
						<Modal showModal={this.state.showModal} handleClose={this.handleDragLeave}>
				          <p>Update this design with new version</p>
				        </Modal>
				        <Share reloadProject={this.reloadImage} userId={this.authUser.id} toggleShare={this.toggleShare} showShare={this.state.showShare} handleClose={this.closeModal} imageId={this.state.image_id} projectId={this.state.project_id}>
				        </Share>
				        <Commentsidebar sortComments={this.sortComments} hideComments={this.hideComments} showComments={this.showComments} showCommentsidebar={this.state.showCommentsidebar} scrTo={this.state.scrTo} comments={this.state.comments} commentId={this.state.commentId} projectId={this.state.project_id} loadComments={this.loadComments}></Commentsidebar>
				        <Modal showModal={this.state.isOpen} handleClose={()=>this.setIsOpen(false)}>
				        	<div className="close" onClick={this.cancelUpload}><FaWindowClose/></div>
				          <div className="uploadblk">
				          	<h3>Attach Files</h3>
				          	{this.state.cfiles?.length>0?<div className="uploaded-files"><ul className="list">
				              {this.state.cfiles?.map((file,i) => (
				                <li key={file.name} className={!this.state.uploadProgress[file.name]['completed'] && !this.state.uploadProgress[file.name]['error']?'file-upload-in-progress':(this.state.uploadProgress[file.name]['completed']?'file-upload-complete':(this.state.uploadProgress[file.name]['error']?'file-upload-error':''))}>
				                	<img src={require('assets/images/complete.svg')} className="icon file-upload-complete-icon" alt="" />
				                	<img src={require('assets/images/error.svg')} className="icon file-upload-error-icon" alt="" />
				                	<div className="html-spinner icon file-upload-spinner"><div></div><div></div><div></div><div></div></div>
				                  <div className="filename">{file.name}</div>
				                  <div className="progress">{this.state.uploadProgress[file.name]['percent']}%</div>
				                	<img src={require('assets/images/delete.svg')} onClick={()=>this.deleteFile(i)} className="updel" alt="" />
				                </li>
				              ))}
				            </ul>
				          	<div className="buttons">
					          	<div className="file-chooser">
					          		<button className="button button--size-medium button--variant-primary">Add More Files</button>
					          		<input id="file-chooser-e3f81f96-8b6e-4dcf-98ff-7261ed3988fe" onChange={this.handleFileChange} type="file" multiple="multiple" />
				          		</div>
				          	</div>
				            <p className="supported-extensions">Supports: JPG, JPEG, PNG, SVG, BMP, GIF, PDF, PSD, AI, EPS, TIFF, RTF, TXT, DOCX, PAGES, ODT, PPTX, ODP, KEY</p>
				            <div className="flex justify-end gap-2">
				              <button
				                onClick={this.cancelUpload}
				                className="px-4 py-2 rounded-md border border-gray-300 text-gray-600"
				              >
				                Cancel
				              </button>
				              <button
				                onClick={this.handleUpload}
				                className="px-4 py-2 rounded-md bg-blue-600 text-white"
				                disabled={this.state.cfiles?.length === 0}
				              >
				                Upload
				              </button>
				            </div>
				            </div>:<div>
				          		<div className="no-uploaded-files"><img src={require('assets/images/nofiles.svg')} alt="" /></div>
					          	<p className="supported-extensions">Supports: JPG, JPEG, PNG, SVG, BMP, GIF, PDF, PSD, AI, EPS, TIFF, RTF, TXT, DOCX, PAGES, ODT, PPTX, ODP, KEY</p>
					          	<div className="buttons">
						          	<div className="file-chooser">
						          		<button className="button button--size-medium button--variant-primary">Browse</button>
						          		<input id="file-chooser-e3f81f96-8b6e-4dcf-98ff-7261ed3988fe" onChange={this.handleFileChange} type="file" multiple="multiple" />
					          		</div>
					          	</div>
					          </div>}
				          </div>
				        </Modal>
				        <Modal showModal={this.state.showConfirm} handleClose={this.closeConfirm}>
									<div className="teammodal">
										<h2>Are you sure?</h2>
				          	<p style={{textAlign:'center'}}>You can't undo this action.</p>
				          	<button onClick={this.closeConfirm}>No</button> <button onClick={this.removeFiles}>Yes</button>
			          	</div>
				        </Modal>
				        <Modal showModal={this.state.showDiscard} handleClose={this.closeDiscard}>
									<div className="teammodal">
										<h2>Discard comment?</h2>
				          	<p style={{textAlign:'center'}}>All changes will be lost.</p>
				          	<button onClick={this.closeDiscard}>Cancel</button> <button onClick={this.confirmDiscard}>Discard</button>
			          	</div>
				        </Modal>
				        <HotKeys keyMap={keyMap} handlers={this.handlersParent}></HotKeys>
				        <Hotkeys keyName="control+c" onKeyUp={this.toggleComments.bind(this)}></Hotkeys>
						<input id="fileInput" {...getInputProps()} />
						
					</div>
				)}
			</Dropzone>
		);
	}
}